export default __webpack_public_path__ + "static/media/SEI_LOGO.d82ddf2d.jpg";